<ng-container *transloco="let t">
  {{ timeRemaining().days }} {{ t('days') }} : {{ timeRemaining().hours }} h :
  {{ timeRemaining().minutes }} m : {{ timeRemaining().seconds }} s
</ng-container>
